<template>
  <div style="margin-top: 50px">
    <div class="hero">
      <div class="hero-ctn">
        <h1>{{ $t('alumniTitle') }}</h1>
        <p>
          {{ $t('alumniDescriotion') }}
        </p>
      </div>
    </div>
    <div style="background-color: #f5f6fa;">
      <div class="container">
        <div class="card" style="padding-bottom: 60px">
          <EmptyData v-if="!stories || !stories.length" message="Belum ada Cerita Alumni saat ini" />
          <div class="items" v-for="(item, idx) in stories" :key="idx"
            @click="goToStoryDetail(item.id, item.title)">
            <div style="height: 240px">
              <img :src="item.image_url" alt="" style="width: 100%; height: 100%; border-radius: 20px 20px 0 0" />
            </div>
            <div class="content">
              <div style="height: 70px;">
                <h2>{{ item.title }}</h2>
              </div>
              <p class="description-class">{{ item.caption }}</p>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: center;" v-if="currentPage < total">
          <Button :name="$t('loadMore')" width="440px" @click="loadMore" />
        </div>
      </div>
    </div>
    <v-card elevation="0" class="call-center-container">
      <v-row style="padding: 20px 8px">
        <v-col cols="12">
          <div class="call-center-title">
            {{ $t('alumniHelpTitle') }}
          </div>
          <div class="call-center-desc">
            {{ $t('alumniHelpDescription') }}
          </div>
        </v-col>
        <v-col cols="12" class="call-center-button" @click="sendWa">
          <v-btn class="btn" elevation="0"> {{ $t('alumniAct') }} </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import Button from "../../others/Button.vue";
import EmptyData from '../../others/EmptyData.vue';

export default {
  name: "MobileAlumniStories",
  components: {
    Button,
    EmptyData
  },
  data() {
    return {
      stories: [],
      currentPage: 1,
      total: 1,
    }
  },
  watch: {
    "$i18n.locale"() {
      this.getStories(true);
    },
  },
  methods: {
    sendWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact WhatsApp - Mobile Alumni Stories',
        value: 1,
      });
      window.open("https://wa.me/6281234567890", "_blank");
    },
    loadMore() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Load More - Page ${this.currentPage + 1}`,
        value: 1,
      });
      this.currentPage++;
      this.getStories();
    },
    async getStories(clear) {
      try {
        const resp = await this.$http.get(`/v1/alumni-stories?page=${this.currentPage}&per_page=9`);
        if (clear) {
          this.stories = [];
        }
        this.stories = this.stories.concat(resp.data.data.storiess);
        if (resp.data.data.total) this.total = Math.floor(resp.data.data.total / 9) + 1;
      } catch (err) {
        console.log(err);
      }
    },
    goToStoryDetail(id, title) {
      this.$gtag.event('click', {
        event_category: 'Alumni Story',
        event_label: `View Story - ${title}`,
        value: 1,
      });
      this.$router.push(`/alumni-stories/${id}`);
    },
  },
  mounted() {
    this.stories = [];
    this.getStories();
  }
}
</script>

<style scoped src="./alumniStories.css"></style>
